import colors from '../theme/colors';
import typography from '../theme/typography';

const styleOverrides = {
  root: {
    '.MuiToggleButton-root': {
      fontWeight: typography.fontWeightRegular,
      lineHeight: 'inherit',
      borderColor: colors.solidGray['200'],
      height: '40px',
    },
    '.MuiToggleButton-root.Mui-selected': {
      borderColor: 'inherit',
    },
  },
};

export default styleOverrides;
